import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { COOKIE_STORAGE } from 'src/app/constants';
import { ApiService } from 'src/app/services/api.service';
import { CookieConsentService } from 'src/app/services/cookie-consent.service';
import { ThemeService } from 'src/app/services/themes.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-confidential-screen',
    templateUrl: './confidential-screen.component.html',
    styleUrls: ['./confidential-screen.component.scss']
})

export class ConfidentialScreenComponent implements OnInit {

    themedata: any;
    fontData: any;
    selectedRegion: any;

    constructor(
        private router: Router,
        private themeService: ThemeService,
        private cookieService: CookieService,
        private apiService: ApiService,
        private consentService: CookieConsentService,
    ) { }

    ngOnInit(): void {
        this.themeService.theme$.subscribe((response) => {
            this.themedata = response;
        });

        this.themeService.selectedFont$.subscribe((response) => {
            this.fontData = response;
        });

        this.themeService.selectedRegion$.subscribe((response) => {
            this.selectedRegion = response;
        })
    }

    agreeConfidentialContent() {
        this.apiService.keyboardActionsSubject.next(false);
    }

    denyConfidentialContent() {
        this.apiService.keyboardActionsSubject.next(false);
        this.consentService.showCookieConsentSubject.next(true);
    }
}
